import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  contentTemplate: any;
  buttonTemplate: any;
  loading = false;
  title: string = '';
  buttonText: string = 'Done';

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      contentTemplate: any;
      modalTitle: string;
      buttonText: string;
      buttonTemplate: any;
    }
  ) {
    this.contentTemplate = data.contentTemplate;
    this.title = data.modalTitle;
    if (data.buttonText && data.buttonText.length >= 2 ) this.buttonText = data.buttonText;
    if (data.buttonTemplate ) this.buttonTemplate = data.buttonTemplate;
  }

  async onSubmit(): Promise<void> {
    this.dialogRef.close(true); // Indicate success to the caller
  }
}
